import { render, staticRenderFns } from "./BankBrowse.vue?vue&type=template&id=ba229be2"
import script from "./BankBrowse.vue?vue&type=script&lang=ts"
export * from "./BankBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba229be2')) {
      api.createRecord('ba229be2', component.options)
    } else {
      api.reload('ba229be2', component.options)
    }
    module.hot.accept("./BankBrowse.vue?vue&type=template&id=ba229be2", function () {
      api.rerender('ba229be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bank/BankBrowse.vue"
export default component.exports